import { usePushSubscription } from 'server';
import {
    IServerError,
    TDepositResponse,
    TWithdrawResponse,
    TDynamicBalancesResponse,
    TGamblingSessionNotification
} from 'js/hooks/socket/types';

import * as Types from './types';
import * as hooks from './hooks';

export const useNotificationSubscriptions = ({ isWrapper = false }: { isWrapper?: boolean } = {}) => {
    const handleUserVerify = hooks.useHandleUserVerify();
    const handleEmailVerification = hooks.useHandleEmailVerification();
    const handleTermsNotification = hooks.useHandleTermsNotification();
    const handleLogoutNotification = hooks.useHandleLogoutNotification({ isWrapper });
    const handleCashierNotification = hooks.useHandleCashierNotification();
    const handleLimitsErrorNotification = hooks.useHandleLimitsErrorNotification();
    const handleBalanceUpdateNotification = hooks.useHandleBalanceUpdateNotification();
    const handleGamblingSessionNotification = hooks.useHandleGamblingSessionNotification();

    // Subscribe to server notifications
    usePushSubscription([33004, 31014], () => handleLogoutNotification);
    usePushSubscription([89900, 35648, 35651], () => (error: IServerError) => handleLimitsErrorNotification(error));
    usePushSubscription([31010], () => (options: Types.ITermsNotificationOptions) => handleTermsNotification(options));
    usePushSubscription([35908], () => (push: TGamblingSessionNotification) => handleGamblingSessionNotification(push));
    usePushSubscription([32010], () => (push: TDynamicBalancesResponse) => handleBalanceUpdateNotification(push));
    usePushSubscription(
        [33015, 33018],
        () => (response: TDepositResponse | TWithdrawResponse) => handleCashierNotification(response)
    );

    // Subscribe to application notifications
    usePushSubscription('userVerify', () => (isSuspended: boolean) => handleUserVerify(isSuspended));
    usePushSubscription('emailVerificationStatus', () => handleEmailVerification);
};
